import React, { Component } from "react";
import { getCustomerLastSyncData } from "../../services/java/java-services";
import { convertUTCToLocalDateTime } from "../../helpers/GlobalFunctions";

export default class HistorySyncModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      loading: true,
      planHistory: [],
    };
  }

  /**
   * @description show Last sync details in customer support user
   * @memberof HistorySyncModal
   */

  componentDidMount() {
    this.fetchLastSyncData();
  }

  fetchLastSyncData() {
    /* istanbul ignore next  */
    getCustomerLastSyncData((err, response) => {
      if (err) {
        this.setState({ errorMessage: err.message, loading: false });
      } else {
        this.setState({
          errorMessage: null,
          loading: false,
          planHistory: response.data?.planHistory || [],
        });
      }
    });
  }

  render() {
    const { planHistory, loading, errorMessage } = this.state;
    return (
      <div className="history-sync-modal" data-testid="history-sync-modal">
        <div className="container">
          {
            /* istanbul ignore next  */
            errorMessage && (
              <div className="row">
                <div
                  className="col-sm-12"
                  style={{ textAlign: "center", color: "red" }}
                >
                  {errorMessage}
                </div>
              </div>
            )
          }

          {loading && (
            <div className="row">
              <div className="col-sm-12" style={{ textAlign: "center" }}>
                Loading...
              </div>
            </div>
          )}

          {!loading && !errorMessage && (
            <div className="container-fluid">
              {planHistory.map((x, index) => (
                <div className="card mb-2 mt-1" key={index}>
                  <div className="card-header">
                    <strong>{x.planType?.toUpperCase()}</strong>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-2">
                          <p className="preop-info p-0 m-0">
                            <strong>Status:</strong>
                          </p>
                          <div className="preop-info">{x.status}</div>
                        </div>
                        <div className="mb-2">
                          <p className="preop-info p-0 m-0">
                            <strong>Total # of Plans:</strong>
                          </p>
                          <div className="preop-info">
                            {x.plans ?? 'N/A'}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-2">
                          <p className="preop-info p-0 m-0">
                            <strong>Last Sync:</strong>
                          </p>
                          <div className="preop-info">
                            {x.lastSync
                              ? convertUTCToLocalDateTime(x.lastSync)
                              : "N/A"}
                          </div>
                        </div>
                        <div className="mb-2">
                          <p className="preop-info p-0 m-0">
                            <strong>Plans Synced:</strong>
                          </p>
                          <div className="preop-info">{x.planSuccessCount}</div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-2">
                          <p className="preop-info p-0 m-0">
                            <strong>Synced By:</strong>
                          </p>
                          <div className="preop-info text-capitalize">
                            {x.syncedBy}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
